// 权证统计
export const queryWarrantStatistics = '/erp/customer/statistics/queryWarrantStatistics';//权证查询银行、金额等按年、月查询
export const queryYearWarrantStatistics = '/erp/customer/statistics/queryYearWarrantStatistics';//权证查询金额、数量等按年查询